export enum AttributeInputs {
	Title = "title",
	Value = "value",
	Label = "label",
	Type = "type",
}
